<template>
  <div :class="classes" >
    <pt-page-title title="批量创建订单">
      <el-button type="primary" plain slot="on-right" :class="$style['created-button']" @click="goNew">创建单个订单</el-button>
    </pt-page-title>
    <pt-sub-title title="批量信息"></pt-sub-title>
    <pt-batch-operation-form></pt-batch-operation-form>
  </div>
</template>

<script>
import ptBatchOperationForm from './pt-batch-operation-form/withData'
// 组件class前缀
const prefixCls = 'pt-batch-operation'

export default {
  name: 'pt-batch-operation',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptBatchOperationForm
  },
  methods: {
    goNew () {
      this.$router.push('/sell-order-form/false/0')
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.created-button{
  margin-left: 40PX;
}
</style>
